module.exports = __webpack_public_path__ + "img/noData.b7f0cc59.png";